/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/currency';
import '../../common/countries';
import '../feeplans_model';
import '../../common/fee_types';
import '../../common/fee';
import '../../common/time';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "feeplans": {
        "nested": {
          "events": {
            "nested": {
              "AssessedFee": {
                "fields": {
                  "assessedFeeToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "feeEventDetails": {
                    "type": ".squareup.feeplans.events.FeeEventDetail",
                    "id": 2,
                    "rule": "optional"
                  },
                  "assessedFeeDetails": {
                    "type": ".squareup.feeplans.events.AssessedFeeDetail",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "AssessedFeeDetail": {
                "fields": {
                  "assessedFeeType": {
                    "type": ".squareup.feeplans.events.AssessedFeeType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "feeAmountWithoutTax": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "feeAmountWithTax": {
                    "type": ".squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "country": {
                    "type": ".squareup.common.countries.Country",
                    "id": 4,
                    "rule": "optional"
                  },
                  "feePlanRateId": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "feePlanProduct": {
                    "type": ".squareup.feeplans.model.FeePlanProduct",
                    "id": 6,
                    "rule": "optional"
                  },
                  "feePlanType": {
                    "type": ".squareup.common.feetypes.FeeplanType",
                    "id": 7,
                    "rule": "optional"
                  },
                  "discountBasisPoints": {
                    "type": "int32",
                    "id": 8,
                    "rule": "optional"
                  },
                  "interchangeCents": {
                    "type": "int32",
                    "id": 9,
                    "rule": "optional"
                  },
                  "taxDetails": {
                    "type": ".squareup.common.TaxDetail",
                    "id": 10,
                    "rule": "repeated"
                  },
                  "feeAppliedAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 11,
                    "rule": "optional"
                  }
                }
              },
              "FeeEventDetail": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "paymentToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "refundUuid": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "orderId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "externalId": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "feeEventType": {
                    "type": ".squareup.feeplans.events.FeeEventType",
                    "id": 5,
                    "rule": "optional"
                  },
                  "transactionType": {
                    "type": ".squareup.feeplans.events.TransactionType",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "AssessedFeeType": {
                "values": {
                  "DEFAULT_ASSESSED_FEE_TYPE_DO_NOT_USE": 0,
                  "PROCESSING_FEE": 1,
                  "SERVICE_FEE": 2
                }
              },
              "FeeEventType": {
                "values": {
                  "DEFAULT_FEE_EVENT_TYPE_DO_NOT_USE": 0,
                  "GIFT_CARD_LOAD": 1
                }
              },
              "TransactionType": {
                "values": {
                  "DEFAULT_TRANSACTION_TYPE_DO_NOT_USE": 0,
                  "CAPTURE": 1,
                  "REFUND": 2,
                  "UNDO_REFUND": 3
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.feeplans?.nested?.events?.nested?.AssessedFee && !$root.nested?.squareup?.nested?.feeplans?.nested?.events?.nested?.AssessedFeeDetail && !$root.nested?.squareup?.nested?.feeplans?.nested?.events?.nested?.FeeEventDetail && !$root.nested?.squareup?.nested?.feeplans?.nested?.events?.nested?.AssessedFeeType && !$root.nested?.squareup?.nested?.feeplans?.nested?.events?.nested?.FeeEventType && !$root.nested?.squareup?.nested?.feeplans?.nested?.events?.nested?.TransactionType) {
  $root.addJSON(jsonData);
}

/**
 * Message used for surfacing fee assessment information to clients
 *
 * SOURCE AssessedFee @ squareup/feeplans/events/assessed_fee_events.proto at 18:1
 */
export const AssessedFee = $root.lookupType('squareup.feeplans.events.AssessedFee');
fixType(AssessedFee, {
  assessedFeeToken: {
    required: true
  },
  feeEventDetails: {
    required: true
  },
  assessedFeeDetails: {
    required: true
  }
});
Builder.createAndAttachToType(AssessedFee);
/**
 * Message used for providing more details into fee assessment calculation
 *
 * SOURCE AssessedFeeDetail @ squareup/feeplans/events/assessed_fee_events.proto at 32:1
 */
export const AssessedFeeDetail = $root.lookupType('squareup.feeplans.events.AssessedFeeDetail');
fixType(AssessedFeeDetail, {
  feeAmountWithoutTax: {
    required: true
  },
  feeAmountWithTax: {
    required: true
  },
  country: {
    required: true
  },
  discountBasisPoints: {
    required: true
  },
  interchangeCents: {
    required: true
  },
  feeAppliedAt: {
    required: true
  }
});
Builder.createAndAttachToType(AssessedFeeDetail);
/**
 * SOURCE FeeEventDetail @ squareup/feeplans/events/assessed_fee_events.proto at 66:1
 */
export const FeeEventDetail = $root.lookupType('squareup.feeplans.events.FeeEventDetail');
fixType(FeeEventDetail, {
  unitToken: {
    required: true
  }
});
Builder.createAndAttachToType(FeeEventDetail);
/**
 * Enum used to differentiate assessed fee types for reporting or settlement needs
 *
 * SOURCE AssessedFeeType @ squareup/feeplans/events/assessed_fee_events.proto at 106:1
 */
export const AssessedFeeType = $root.lookupEnum('squareup.feeplans.events.AssessedFeeType').values;
/**
 * Enum used to differentiate fee event which was triggered to initiate assessment
 *
 * SOURCE FeeEventType @ squareup/feeplans/events/assessed_fee_events.proto at 115:1
 */
export const FeeEventType = $root.lookupEnum('squareup.feeplans.events.FeeEventType').values;
/**
 * Enum used to record the type of transaction which was triggered to initiate assessment
 *
 * SOURCE TransactionType @ squareup/feeplans/events/assessed_fee_events.proto at 123:1
 */
export const TransactionType = $root.lookupEnum('squareup.feeplans.events.TransactionType').values;